// Condiciones de vuelo para el cálculo aerodinámico. Ver docs/theory/barrowman.md y drag.md.
import type { AirState } from '../atmosphere/isa';

/** Alturas de rugosidad de superficie típicas (m). Valores de diseño de referencia. */
export const ROUGHNESS = {
  polished: 0.5e-6,
  smooth: 10e-6,
  normal: 50e-6,
  rough: 150e-6,
  rawWood: 300e-6,
} as const;

export interface FlightConditions {
  /** Estado del aire a la altitud actual. */
  readonly air: AirState;
  /** Velocidad del aire respecto al cohete (m/s). */
  readonly airspeed: number;
  /** Ángulo de ataque (rad). */
  readonly angleOfAttack: number;
  /** Altura de rugosidad de la superficie (m). */
  readonly roughness: number;
}

export const machOf = (c: FlightConditions): number => c.airspeed / c.air.speedOfSound;

/** Ángulo de pérdida por defecto (rad). Supuesto de diseño. */
export const DEFAULT_STALL_ANGLE = (15 * Math.PI) / 180;

/** Mach máximo con el que se evalúan las aletas; por encima se mantiene constante. */
export const FIN_MACH_CAP = 0.9;
